import { useEffect, useState } from 'react'
import { api } from '../lib/api/client'

const cache = new Map<string, string>()
const inflight = new Map<string, Promise<string>>()

function load(id: string): Promise<string> {
  const cached = cache.get(id)
  if (cached) return Promise.resolve(cached)

  const existing = inflight.get(id)
  if (existing) return existing

  const request = api
    .pictureBlob(id)
    .then((blob) => {
      const url = URL.createObjectURL(blob)
      cache.set(id, url)
      inflight.delete(id)
      return url
    })
    .catch((error) => {
      inflight.delete(id)
      throw error
    })

  inflight.set(id, request)
  return request
}

export function usePictureUrl(id: string | null | undefined): string | undefined {
  const [url, setUrl] = useState<string | undefined>(() => (id ? cache.get(id) : undefined))

  useEffect(() => {
    if (!id) {
      setUrl(undefined)
      return
    }
    let live = true
    load(id)
      .then((resolved) => live && setUrl(resolved))
      .catch(() => live && setUrl(undefined))
    return () => {
      live = false
    }
  }, [id])

  return url
}
